import { AdaptiveFilterButtons } from '@/features/adaptiveFilterButtons'
import {
  FINANCE_STATUS_MAP,
  MobileBlockFinance,
  useFinances,
  getFinanceColumns,
} from '@/features/finance'
import { FilterButtonModel } from '@/shared/components/MobileFilterButtons/MobileFilterButtons'
import { PageTitle } from '@/shared/components/PageTitle/PageTitle'
import { useState } from 'react'
import { BaseTable, BaseTableSkeleton } from 'syncra-storybook/features'

const filterButtons: FilterButtonModel[] = [
  { name: 'Все', label: 'all', index: 1 },
  { name: 'Выводы', label: 'withdrawal', index: 2 },
  { name: 'Пополнения', label: 'deposit', index: 3 },
]

export const FinancePage = () => {
  const [selectedStatus, setSelectedStatus] = useState(1)
  const [skip, setSkip] = useState(0)

  const status = FINANCE_STATUS_MAP[selectedStatus]

  const { data } = useFinances({ status: status ?? 1, skip })

  const handlePageChange = (newSkip: number) => {
    setSkip(newSkip)
  }

  return (
    <div>
      <div className="flex md:flex-row flex-col md:justify-between gap-[10px] mb-6 md:mb-8">
        <PageTitle title="Финансы" />
        {/* <DatePickerWithRange variant={isMobile ? 'default' : 'outline'} size="lg" /> */}
      </div>

      <div className="flex flex-wrap items-center gap-0.5 mb-[30px] md:mb-8">
        <AdaptiveFilterButtons
          selectedBtn={selectedStatus}
          setSelectedBtn={(index) => {
            setSelectedStatus(index)
            setSkip(0)
          }}
          filterButtons={filterButtons}
          minWidthMobile="150px"
          className="flex-1"
        />
      </div>
      {data.error ? (
        <p>Ошибка загрузки данных.</p>
      ) : data.isLoading ? (
        <BaseTableSkeleton />
      ) : !data.items || data.items.length === 0 ? (
        <p>Данных нет.</p>
      ) : (
        <BaseTable
          data={data.items}
          columns={getFinanceColumns({ isDashboard: false })}
          totalItems={data.totalItems}
          skip={data.skip}
          cardClasses="border-0 flex flex-col gap-6 md:gap-8"
          cardPadding="none"
          onPageChange={handlePageChange}
          mobileCards={data.items?.map((finance) => (
            <MobileBlockFinance key={finance.id} finance={finance} allData={data.items} />
          ))}
        />
      )}
    </div>
  )
}
